import { EBool } from '~/src/dash/api/types/bool';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IMenuList } from '~/src/dash/types/menuList';

interface IAudienceSegmentDataPartner {
  key: string;
  title: string;
  value: string;
}

export const PARTNERS = {
  FirstParty: {
    key: 'FirstParty',
    title: 'First Party',
    value: '',
  },
  LiveRamp: {
    key: 'LiveRamp',
    title: 'LiveRamp',
    value: 'LiveRamp',
  },
  Cadent: {
    key: 'Cadent',
    title: 'Cadent',
    value: 'Cadent',
  },
  TransUnion: {
    key: 'TransUnion',
    title: 'TransUnion',
    value: 'TransUnion',
  },
  SamsungDMP: {
    key: 'SamsungDMP',
    title: 'Samsung DMP',
    value: 'SamsungDMP',
  },
  OnePlusXDMP: {
    key: 'OnePlusXDMP',
    title: '1PlusX DMP',
    value: '1PlusXDMP',
  },
} as Record<string, IAudienceSegmentDataPartner>;

export const generatePartnersList = (
  session: ISessionState,
): Promise<Record<string, IMenuList>> => {
  const { publisher } = session;
  const filteredPartners = ['FirstParty'];
  if (
    publisher.LiverampEnabled === EBool.EBool_TRUE &&
    (publisher.LiverampDataStore || publisher.LiverampOTTHubCustomerID)
  ) {
    filteredPartners.push('LiveRamp');
  }
  if (publisher.CadentEnabled === EBool.EBool_TRUE) {
    filteredPartners.push('Cadent');
  }
  if (publisher.TransunionEnabled === EBool.EBool_TRUE) {
    filteredPartners.push('TransUnion');
  }
  if (publisher.SamsungDMPEnabled === EBool.EBool_TRUE) {
    filteredPartners.push('SamsungDMP');
  }
  if (publisher.OnePlusXDMPEnabled === EBool.EBool_TRUE) {
    filteredPartners.push('OnePlusXDMP');
  }
  const partnersList: IMenuList = {};
  filteredPartners.forEach((partner) => {
    partnersList[partner] = {
      ID: partner,
      title: PARTNERS[partner as string].title,
      selected: false,
    };
  });
  return new Promise((resolve) => resolve({ Partners: partnersList }));
};
